let ServerConfigs = {
    url: document.location.origin,
    // url: "https://countingwell.com", // For Mobile app as well as Electron Production Build
    // url: "http://167.71.231.102", // For Test Environment
    // url: "http://localhost:3000",
    timeout: 30
}

export default ServerConfigs;
